fragment InboundWhatsAppRulesFragment on InboundWhatsAppRules {
    assignment {
        strategy
        assignedUser {
            id
            name
        }
    }
    leadCreation {
        enabled
        stageset {
            id
            name
        }
        tags {
            id
            name
        }
    }
}
